//To use this, put this in your HTML:
//  <document-list id="docsChooser" #docsChooser></document-list>
//Then put this in your TS file:
//  @ViewChild('docsChooser') docsChooser: DocumentListComponent;
//Then initialize it by calling the init() function. 
//The data source for this control is an array of DesignationChoice objects. Each object will appear as a table row in the UI. Each row will have an amount, a dropdown of designations, and then other dropdowns of sub-designations that appear/disappear/fill depending on which designation is chosen.
import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { WebService, ContributionDocument,  } from '../../shared/web-service/web.service';
import { GridOptions } from 'ag-grid-community';

@Component({
  selector: 'document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentListComponent implements OnInit {
  @ViewChild('modalAddEdit') modalAddEdit;
  gridOptionsDocuments: GridOptions;
  objectAddEdit: ContributionDocument;
  modalTitle: string;
  somethingChanged: boolean;
  msgBox: any;
  arrayIndexBeingEdited: number;
  rowDataGrid: ContributionDocument[]; //data source for grid

  static staticInstance: DocumentListComponent;

  constructor(private webService: WebService) {
    this.objectAddEdit = new ContributionDocument(0, '', '', '', '', null); //This is just a placeholder so we don't get an error on page load when the dialog form binds to this object.

    this.gridOptionsDocuments = <GridOptions>{
      pagination: false,
      suppressCellSelection: true,
      suppressDragLeaveHidesColumns : true,
      suppressRowClickSelection: true,
      suppressColumnVirtualisation: true, //This makes it resize the columns correctly at page load (even the ones not shown yet because of scrolling)
      defaultColDef: { sortable: true, filter: true, resizable: true },
      columnDefs: [
        { headerName: 'Actions', field: 'contDocNo', suppressMenu: true, sortable: false, cellRenderer: this.actionCellRendererFunc, width: 160 },
        { headerName: 'Name', field: 'docName', width: 150 },
        { headerName: 'Description', field: 'docDesc', width: 480 },
      ],
    };
  }

  ngOnInit() {
    DocumentListComponent.staticInstance = this;
  }

  //Call this to initalize the control. Use the "edit" param to let us know if it's edit or add (pass false for add). Pass in "allowAddMoreRows" as true if the user has the ability to click a link to add more items to the data source array (which will then add a row to the UI). If this control can add multiple rows, then totalCountElemID identifies the field that holds the amount that all of the des amount rows must add up to.
  initDocsList(docs: ContributionDocument[], msgBox) {
    this.rowDataGrid = docs;
    this.msgBox = msgBox;
    this.somethingChanged = false;
    this.gridOptionsDocuments.api.setRowData(this.rowDataGrid);
  }

  //This funtion returns either an HTML string or object that is the HTML for the cell. 
  //passed in: params.data is the object that is the data source for the row.
  actionCellRendererFunc(params) {
    var span = document.createElement('span');

    var link = document.createElement('a');
    link.innerHTML = 'Edit';
    link.setAttribute('href', 'javascript:void(0);');
    link.addEventListener('click', () => {
      DocumentListComponent.staticInstance.editDocument(params.data);
    });
    span.appendChild(link);

    var link = document.createElement('a');
    link.innerHTML = 'Delete';
    link.setAttribute('href', 'javascript:void(0);');
    link.className = "link-in-grid-row";
    link.addEventListener('click', () => {
      DocumentListComponent.staticInstance.deleteDocument(params.data);
    });
    span.appendChild(link);

    if (params.data.contDocNo > 0) {
      var link = document.createElement('a');
      link.innerHTML = 'Download';
      link.target = "_blank";
      link.setAttribute('href', params.data.docUrl);
      link.setAttribute('download', params.data.originalFileName);
      link.className = "link-in-grid-row";
      span.appendChild(link);
    }
    return span;
  }

  // Open the dialog to add a document
  addDocument() {
    this.modalAddEdit.show();
    this.objectAddEdit = new ContributionDocument(0, '', '', '', '', null);
    this.modalTitle = 'Add document';
    $("#fileUpload").val(''); //clear out the file upload element
    this.arrayIndexBeingEdited = -1;
    //We have to use setTimeout to set the focus to the first field because you can't set focus until it appears, which takes a moment.
    setTimeout(() => { $("#DocName").focus() }, 300);
  }

  // Open the dialog to edit a document.
  editDocument(obj: ContributionDocument) {
    this.modalAddEdit.show();
    //Find index in array of the document being edited.
    for (let i = 0; i < this.rowDataGrid.length; i++) {
      if (this.rowDataGrid[i] == obj) {
        this.arrayIndexBeingEdited = i;
        break;
      }
    }
    this.objectAddEdit = jQuery.extend({}, obj); //This makes a copy of the document data source for the dialog, so we aren't changing the original, in case the dialog is cancelled.
    this.modalTitle = 'Edit document';
    $("#fileUpload").val(''); //clear out the file upload element
  }

  // Event fired once the user has chosen a file to upload. We only let them choose one file at a time, but the FileList object theoretically could let the user upload multiple files. So we only care about the first one in the list.
  chosenFile(files: FileList) {
    if (files.length == 0) {
      //This can happen if the user clicks on the file input to select a file and then chooses Cancel, which removes any previously-selected file from the file input.
      this.objectAddEdit.newFile = null;
      this.objectAddEdit.originalFileName = null;
      return;
    }

    //validate the file chosen to be uploaded. The first check is to make sure it's not an executable file (just looking at the file extension).
    const fileNameExtension = files[0].name.split('.').pop().toUpperCase();
    const exeExtentions = ["ACTION", "APK", "APP", "BAT", "BIN", "CMD", "COM", "COMMAND", "CPL", "CSH", "EXE", "GADGET", "INF1", "INS", "INX", "IPA", "ISU", "JOB", "JSE", "KSH", "LNK", "MSC", "MSI", "MSP", "MST", "OSX", "OUT", "PAF", "PIF", "PRG", "PS1", "REG", "RGS", "RUN", "SCR", "SCT", "SHB", "SHS", "U3P", "VB", "VBE", "VBS", "VBSCRIPT", "WORKFLOW", "WS", "WSF", "WSH"];

    if (exeExtentions.includes(fileNameExtension)) {
      this.msgBox.show("Error", 'This file cannot be uploaded because its file extension (' + fileNameExtension + ') denotes an executable file. If this file must be uploaded, you can change its name to a different extension. Please select a different file.', false);
      $("#fileUpload").val(''); //clear out the file upload element
    }
    else if (files[0].size > 10000000) {
      this.msgBox.show("Error", 'The file size must be less than 10 MB. Please select a different file.', false);
      $("#fileUpload").val(''); //clear out the file upload element
    }
    else if (files[0].size == 0) {
      this.msgBox.show("Error", 'The file size must be greater than 0. Please select a different file.', false);
      $("#fileUpload").val(''); //clear out the file upload element
    }
    else if (files[0].name.length > 90) {
      this.msgBox.show("Error", 'The file name cannot be longer than 90 characters. Please select a different file.', false);
      $("#fileUpload").val(''); //clear out the file upload element
    }
    else {
      this.objectAddEdit.newFile = files[0];
      this.objectAddEdit.originalFileName = files[0].name;
    }
  }

  // Save document to the DB and close the dialog.
  finishAddEditDocument() {
    // Any field that cannot be blank will have the attribute "data-not-blank". If any of them are not filled in, we show the validation text and highlight the input by putting a class on them. Only save the data to the server and close the dialog if there are no validation errors.
    let blankError: boolean = false;

    $("*[data-not-blank-doc]").each(function (index) {
      let val = $(this).val();
      if ((val == '' || val === null || val === "$") && $(this).is(":visible")) { // We only pay attention to this field if it's visible. Sometimes the fields are invisible, so it's OK if they are blank in that case.
        blankError = true;
        $(this).addClass("validation-error");
      }
      else {
        $(this).removeClass("validation-error");
      }
    });

    if (this.objectAddEdit.contDocNo == 0 && !this.objectAddEdit.newFile) {
      blankError = true;
      $("#fileUpload").addClass("validation-error");
    }
    else
      $("#fileUpload").removeClass("validation-error");

    if (blankError) {
      $("#validationErrorTdDocs").text("Fields marked with * cannot be blank");
      $("#validationMsgDocs").css("display", "");
      return;
    }

    //There's no validation error
    $("#validationMsgDocs").css("display", "none");

    if (this.arrayIndexBeingEdited < 0)
      this.rowDataGrid.push(this.objectAddEdit); //add mode, add the new document to the data source for the grid
    else
      this.rowDataGrid[this.arrayIndexBeingEdited] = this.objectAddEdit; //edit mode, so we replace the matching document in our grid array with the one being edited.
    this.modalAddEdit.hide();
    this.gridOptionsDocuments.api.setRowData(this.rowDataGrid);
    this.somethingChanged = true;
  }

  //Cancel out of the add/edit dailog
  cancelAddEditDocument() {
    this.modalAddEdit.hide();
    //Get rid of validation errors for when the dialog appears next time.
    $("*[data-not-blank]").each(function (index) {
      $(this).removeClass("validation-error");
    });
    $("#fileUpload").removeClass("validation-error");
    $("#validationMsgDocs").css("display", "none");
  }

  //Delete document from the grid.
  deleteDocument(document: ContributionDocument) {
    for (let i = 0; i < this.rowDataGrid.length; i++) {
      if (this.rowDataGrid[i] == document) {
        this.rowDataGrid.splice(i, 1); //This removes a doc from the array
        break;
      }
    }
    this.gridOptionsDocuments.api.setRowData(this.rowDataGrid);
    this.somethingChanged = true;
  }
}
